<template>

  <div
    class="feed-content"
    :class="{'box-loading': loading}">
    
    <div
      class="photo"
      v-if="!newMail && activity.author_user">
      <Avatar
        :src="imgSrc"
        :name="activity.email.type === 'sent' ? activity.author_user.name : activity.candidate.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>
    <!--end photo-->

    <div
      class="content"
      v-if="!newMail">
      
      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions">
        <email-actions
          :value="activity.email"
          @create="createEmail"
          @delete="deleteEmail">
          </email-actions>
      </div>

      <div>
        <strong>{{ activity.email.subject }}</strong>
      </div>

      <div
        class="alert alert-danger mt-3"
        v-if="activity.email.delivery_notification === 'bounce'">
        <b>Message not delivered.</b> There was a problem delivering your message.
      </div>
      <div
        class="alert alert-danger mt-2"
        v-if="activity.email.delivery_status === 'failed'">
        <b>Your message was not sent.</b> An error occurred while trying to send your message
      </div>

      <div class="mt-2">
        <div>
          {{ $t('From') }}: 
          <i
            v-if="activity.email.from"
            v-tooltip="activity.email.from.email">
            {{ activity.email.from.name }}
            </i>
        </div>
        <div
          v-if="activity.email.to">
          {{ $t('To') }}: 
          <i>
            <span
              v-for="(item, index) in activity.email.to"
              :key="index"
              v-tooltip="item.email">
              {{ item.name }}{{ index + 1 < activity.email.to ? ', ' : '' }}
              </span>
            </i>
        </div>
        <div
          v-if="activity.email.cc && activity.email.cc.length">
          Cópia para
          <i>
            <span
              v-for="(item, index) in activity.email.cc"
              :key="index"
              v-tooltip="item.email">
              {{ item.name }}{{ index + 1 < activity.email.cc.length ? ', ' : '' }}
              </span>
            </i>
        </div>
        <div
          v-if="activity.email.bcc && activity.email.bcc.length">
          Cópia oculta para
          <i>
            <span
              v-for="(item, index) in activity.email.bcc"
              :key="index"
              v-tooltip="item.email">
              {{ item.name }}{{ index + 1 < activity.email.bcc.length ? ', ' : '' }}
              </span>
            </i>
        </div>
      </div>

      <div
        class="mt-2 text-warning"
        v-if="activity.email.delivery_status === 'scheduled'">
        <i class="fas fa-clock" /> <b>{{ $d(new Date(activity.email.send_at), 'long') }}</b>
      </div>

      <hr>

      <div>
        <div v-if="!showAll">{{ activity.email.shurttext }}</div>
        
        <HtmlFrame
          v-if="showAll"
          :html="activity.email.body"
          :url="activity.email.body_media ? activity.email.body_media.url : null" />

        <div class="mt-1">
          <a
            href="javascript:void(0)"
            @click="showAll=!showAll">
            {{ showAll ? $t('Show less') : $t('Show more') }}
            </a>
        </div>
      </div>

      <div
        v-if="activity.email.attachments_media.length"
        class="mt-2">
        <div class="attachments-list ">
          <a 
            v-for="(file, index) in activity.email.attachments_media"
            :key="index"
            :href="file.url"
            target="_blank">
            <i class="fas fa-paperclip" />
            {{ $subString(file.title, 40) }}
            </a>
        </div>
      </div>

      <div class="mt-2">
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span>
            -
            </span> 
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>
      </div>

    </div>
    <!--end content-->

    <div
      class="content"
      v-if="newMail">
      <email-form
        :initValue="newMail"
        @created="createdEmail"
        @cancel="editCancel">
        </email-form> 
    </div>
    <!--end content-->
    
  </div>

</template>

<script>
import config from '@/config'
import EmailForm from '@/components/Email/EmailForm'
import EmailActions from '@/components/Email/EmailActions'
import HtmlFrame from '@/components/Fields/HtmlFrame'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateEmailItem',
  components: {
    EmailForm,
    EmailActions,
    HtmlFrame,
    Avatar
  },
  props: [
    'activity'
  ],
  data () {
    return {
      loading: false,
      newMail: false,
      showAll: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.email.type === 'sent' ? this.activity.author_user.photo_media_url : this.activity.candidate.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    editCancel () {
      this.newMail = false
    },
    createEmail (data) {
      this.newMail = data
    },
    deleteEmail (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteEmail', id)
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
          this.$store.dispatch('deleteActivity', this.activity._id)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    /*
    createdEmail
    */
    createdEmail (email) {
      this.editCancel()
      return this.$store
      .dispatch('refreshSelectActivities')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedEmailItem.vue